import AutoLayout from "../../Layouts/AutoLayout/AutoLayout";
import FontText from "../../FontText/FontText";
import Icon from "../../Icon/Icon";
import React from "react";
import RippleEffect from "../../RippleEffect/RippleEffect";
import styled, { css } from "styled-components";
import {
  AutoLayoutAlignEnum,
  AutoLayoutDirectionEnum,
} from "../../Layouts/AutoLayout/AutoLayoutEnums";
import { FontSizeEnum, FontTypeEnum } from "../../FontText/FontTextEnums";
import { ITheme } from "../../Themes/ThemeTypes";
import { RippleEffectShapeEnum } from "../../RippleEffect/RippleEffectShapeEnum";
import { ThemeColorEnum, ThemeIconEnum } from "../../Themes/ThemeEnums";
import { useSelector } from "react-redux";
import { AppCoreState } from "../../../../Redux/AppCoreReducer";
import { BaseTheme } from "../../Themes/BaseTheme";

export const FAB_VIEWPORT_OFFSET_PX = 16;
export const FAB_HEIGHT_PX = 56;

const Div = styled("div")`
  @media (max-width: ${() => BaseTheme.responsive.mobile}px) {
    position: fixed;
    bottom: ${FAB_VIEWPORT_OFFSET_PX}px;
    right: ${FAB_VIEWPORT_OFFSET_PX}px;
  }
`;

const ButtonAutoLayout = styled(AutoLayout)<{
  theme: ITheme;
  $isRail: boolean;
}>`
  height: ${FAB_HEIGHT_PX}px;
  width: 100%;
  border-radius: 16px;
  padding-left: 16px;
  cursor: pointer;
  white-space: nowrap;
  background-color: rgb(${(props) => props.theme.colors.tertiary_container});
  gap: 12px;
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  .font-text {
    transition: opacity ${(props) => props.theme.base.left_nav.transition_length}
      ${(props) => props.theme.base.motion.easing.standard};
    ${(props) => {
      if (props.$isRail) {
        return css`
          opacity: 0;
        `;
      } else {
        return css`
          opacity: 1;
        `;
      }
    }};
  }

  @media (max-width: ${() => BaseTheme.responsive.mobile}px) {
    .font-text {
      opacity: 1;
    }

    width: auto;
    padding-right: 20px;
    min-width: 80px;
    box-shadow: ${(props) => props.theme.base.elevation.level3_shadow};
  }
`;

interface ExtendedFabButtonProps {
  icon: ThemeIconEnum;

  /**
   * The label text for the button.
   */
  label: string;
}

const ExtendedFabButton: React.FC<ExtendedFabButtonProps> = ({ icon, label }) => {
  const isAppLeftNavToggled = useSelector(
    (state: { core: AppCoreState }) => state.core.isAppLeftNavToggled,
  );

  return (
    <Div>
      <RippleEffect shape={RippleEffectShapeEnum.RADIUS_16}>
        <ButtonAutoLayout
          $direction={AutoLayoutDirectionEnum.HORIZONTAL}
          $align={AutoLayoutAlignEnum.LEFT}
          $isRail={isAppLeftNavToggled}
        >
          <Icon icon={icon} color={ThemeColorEnum.ON_TERTIARY_CONTAINER} />
          <div className="font-text">
            <FontText
              text={label}
              $color={ThemeColorEnum.ON_TERTIARY_CONTAINER}
              $fontType={FontTypeEnum.LABEL}
              $fontSize={FontSizeEnum.LARGE}
            />
          </div>
        </ButtonAutoLayout>
      </RippleEffect>
    </Div>
  );
};

export default ExtendedFabButton;
